import { db, cache, remove, put, URL } from 'utils';
import { fetch } from './fetch';
import { getSelectedConv, getMessages as selectedMessages } from 'selectors';
import { LOAD_TASKS, LOAD_MATERIALS } from './group';
import { createPM } from './pm';
import * as ui from './ui';
import { selectConv, removeTmpPM } from './index';
import { PAGE_SIZE } from 'constants';

export const UPDATE_CONV = 'CONV.UPDATE_CONV';
export const SET_STORED_CONVS = 'CONV.SET_STORED_CONVS';
export const ADD_MESSAGES = 'CONV.ADD_MESSAGES';
export const UPDATE_MESSAGES = 'CONV.UPDATE_MESSAGES';
export const LOAD_MESSAGES = 'CONV.LOAD_MESSAGES';
export const LOAD_PREV_MESSAGES = 'CONV.LOAD_PREV_MESSAGES';
export const LOAD_NEXT_MESSAGES = 'CONV.LOAD_NEXT_MESSAGES';
export const UPDATE_PREV_MESSAGES = 'CONV.UPDATE_PREV_MESSAGES';
export const LOAD_MEMBERS = 'CONV.LOAD_MEMBERS';
export const UPDATE_MEMBERS = 'CONV.UPDATE_MEMBERS';
export const EMPTY_PAGE_MESSAGES = 'CONV.EMPTY_PAGE_MESSAGES';
export const PROCESS_MSG_UPLOAD = 'CONV.PROCESS_MSG_UPLOAD';
export const ADD_MEMBERS = 'CONV.ADD_MEMBERS';

export const getConvs = user_id => (dispatch, getState) => {
  db.watchAdded(`user_conv/${user_id}`, usr_conv => {
    if (usr_conv.inactive) {
      dispatch({ type: UPDATE_CONV, payload: usr_conv });
    } else {
      usr_conv.new = true;
      dispatch(watchConvInfo(user_id, usr_conv));
    }
  });

  db.watchChanged(`user_conv/${user_id}`, usr_conv => {
    const conv = getSelectedConv({ id: usr_conv.id });
    // checking if the user Rejoined the group by compairing the current state with the future state
    const is_rejoined = conv.inactive && !usr_conv.inactive;
    if (usr_conv.inactive) {
      dispatch(deactivateConv(usr_conv));
    } else if (is_rejoined) {
      usr_conv.new = true;
      dispatch(watchConvInfo(user_id, usr_conv));
    } else {
      dispatch({
        type: UPDATE_CONV,
        payload: {
          ...conv,
          ...usr_conv,
          unread_msg: conv.watching && conv.watching[user_id] ? 0 : conv.total_msg - usr_conv.read_msg
        }
      });
    }
  });
};

const watchConvInfo = (user_id, usr_conv) => (dispatch, getState) => {
  db.watch(`convs/${usr_conv.id}/info`, conv_info => {
    if (conv_info.type === 'PM') {
      const { name, id, photo } = Object.values(conv_info.members).find(obj => user_id !== obj.id);
      conv_info.title = name;
      conv_info.member_id = id;
      conv_info.photo = photo;
    }

    // making sure if there is cached convs in the storage, the new user_conv data is assigned
    const new_usr_conv = usr_conv.new ? usr_conv : {};
    delete usr_conv.new;
    const { read_msg, muted, last_read_msg_id, is_admin, order, is_pm, online } = { ...getSelectedConv({ id: usr_conv.id }), ...new_usr_conv };
    const conv = { ...conv_info, read_msg, last_read_msg_id, muted, is_admin, order, is_pm, online };

    conv.unread_msg = conv.watching && conv.watching[user_id] ? 0 : conv.total_msg - conv.read_msg;
    dispatch({ type: UPDATE_CONV, payload: conv });

    // after dispatching and making sure a conv is in the state, you listen for online pm
    conv.is_pm && dispatch(pmOnline(conv));

    const state = getState();
    if (conv_info.type === 'PM' && state.ui.tmp_pm && conv_info.members[state.ui.tmp_pm.id]) {
      selectConv(conv_info);
      removeTmpPM();
    }
  });
};
export const setStoredConvs = convs => ({ type: SET_STORED_CONVS, payload: convs });
export const pmOnline = conv => async (dispatch, getState) => {
  if (!cache.get(`watch_online_${conv.member_id}`)) {
    cache.set(`watch_online_${conv.member_id}`, true);
    db.watch(`users/${conv.member_id}/online`, is_online => {
      const result = getSelectedConv({ id: conv.id });
      dispatch({ type: UPDATE_CONV, payload: { ...result, online: is_online } });
    });
  }
};

export const setWatching = ({ conv_id, is_group, tmp_pm }) => async (dispatch, getState) => {
  const user = getState().user;
  !tmp_pm && (await db.set(`convs/${conv_id}/info/watching/${user.id}/${user.current_session}`, true, null));
};

export const unsetWatching = ({ conv_id, is_group, tmp_pm }) => async (dispatch, getState) => {
  const state = getState();
  const user = state.user;
  !tmp_pm && db.set(`convs/${conv_id}/info/watching/${user.id}/${user.current_session}`, null);
  !tmp_pm && dispatch(setRead(conv_id));
};

const setRead = conv_id => async (dispatch, getState) => {
  const user = getState().user;
  const { total_msg, last_msg, type } = getSelectedConv({ id: conv_id }) || {};

  let update = {};
  update[`user_conv/${user.id}/${conv_id}/read_msg/`] = total_msg;
  type === 'GROUP' ? (update[`convs/${conv_id}/members/${user.id}/read_msg/`] = total_msg) : (update[`convs/${conv_id}/info/members/${user.id}/read_msg/`] = total_msg);
  update[`user_conv/${user.id}/${conv_id}/last_read_msg_id/`] = last_msg.id;
  total_msg && db.update(update);
};

export const goToPage = (conv_id, pointer) => (dispatch, getState) => {
  const once = once => dispatch({ type: LOAD_MESSAGES, payload: { id: conv_id, data: once }, attr_name: 'page_messages' });
  once({});
  db.loadAndWatchPage(`convs/${conv_id}/messages/`, { once, pointer });
};

export const getMessages = conv => (dispatch, getState) => {
  const { total_msg, read_msg, last_read_msg_id } = getSelectedConv({ id: conv.id }) || {};
  let once = once => dispatch({ type: LOAD_MESSAGES, payload: { id: conv.id, data: once }, attr_name: 'recent_messages' });
  let added = added => dispatch({ type: ADD_MESSAGES, payload: { id: conv.id, data: added }, attr_name: 'recent_messages' });
  let changed = changed => dispatch({ type: UPDATE_MESSAGES, payload: { id: conv.id, data: changed } });
  db.loadAndWatch(`convs/${conv.id}/messages/`, { once, added, changed, page_size: PAGE_SIZE });

  if (total_msg - read_msg > PAGE_SIZE) {
    dispatch(goToPage(conv.id, last_read_msg_id));
  }
};

export const getPrevMessages = conv_id => (dispatch, getState) => {
  const msgs = selectedMessages(conv_id);
  const msg = msgs[msgs.length - 1];
  dispatch(ui.getPrevMessages(conv_id));
  const once = once => {
    dispatch({ type: LOAD_PREV_MESSAGES, payload: { id: conv_id, data: once }, attr_name: 'recent_messages' });
    dispatch(ui.getPrevMessages(false));
  };
  db.loadPrevPage(`convs/${conv_id}/messages/`, { once, pointer: msg.id });
};

export const getNextMessages = conv_id => (dispatch, getState) => {
  const msgs = selectedMessages(conv_id);
  const msg = msgs[0];
  dispatch(ui.getNextMessages(conv_id));
  const once = once => {
    dispatch({ type: LOAD_NEXT_MESSAGES, payload: { id: conv_id, data: once }, attr_name: 'recent_messages' });
    dispatch(ui.getNextMessages(false));
  };
  db.loadNextPage(`convs/${conv_id}/messages/`, { once, pointer: msg.id });
};

export const emptyPageMessages = conv_id => (dispatch, getState) => {
  dispatch({ type: EMPTY_PAGE_MESSAGES, payload: { id: conv_id }, attr_name: 'page_messages' });
};

export const sendMessage = ({ msgs, conv_id, tmp_pm }) => (dispatch, getState) => {
  // if this is the first msg in a PM conv
  if (tmp_pm) {
    const member_id = tmp_pm.id;
    dispatch(createPM(member_id, msgs));
  } else {
    const { total_msg } = getSelectedConv({ id: conv_id }) || {};
    let update = {};
    update[`convs/${conv_id}/info/total_msg`] = total_msg + msgs.length;
    update[`convs/${conv_id}/info/last_msg`] = msgs.slice(-1)[0];
    msgs.forEach(m => {
      update[`convs/${conv_id}/messages/${m.id}/`] = m;
    });
    total_msg && db.update(update);
    dispatch(setRead(conv_id));
  }
};

export const processMsgUpload = ({ msg_id, conv_id }) => (dispatch, getState) => {
  const request = { url: URL.CONV.PROCESS_MSG_UPLOAD(conv_id, msg_id), method: put };
  fetch(request, PROCESS_MSG_UPLOAD);
};

export const deleteMsg = ({ msg_id, is_for_all }) => (dispatch, state) => {
  // todo: this is wrong,  bug for sure; you should pass conv_id
  const { id } = getSelectedConv();
  const request = { url: URL.CONV.DELETE_MSG(id), method: remove, params: { msg_id, is_for_all } };
  fetch(request, UPDATE_MESSAGES);
};

export const getMembers = conv_id => (dispatch, getState) => {
  const once = once => {
    dispatch({
      type: LOAD_MEMBERS,
      payload: { id: conv_id, data: once }
    });
  };

  const added = added => dispatch({ type: ADD_MEMBERS, payload: { id: conv_id, data: added } });
  const changed = changed => dispatch({ type: UPDATE_MEMBERS, payload: { id: conv_id, data: changed } });

  db.loadAndWatch(`convs/${conv_id}/members`, { once, added, changed });
};

export const setTypingIndicator = ({ conv_id }) => (dispatch, getState) => {
  const user = getState().user;
  const indicator_obj = typingIndicatorTemplate(user);
  db.set(`convs/${conv_id}/info/typing_indicator/${user.id}/`, indicator_obj, null);
};

export const unsetTypingIndicator = ({ conv_id }) => (dispatch, getState) => {
  const user = getState().user;
  db.set(`convs/${conv_id}/info/typing_indicator/${user.id}/`, null);
};

const typingIndicatorTemplate = ({ id, name }) => ({
  created: db.time(),
  id,
  name
});

const deactivateConv = usr_conv => (dispatch, getState) => {
  db.off(`convs/${usr_conv.id}/info`);
  db.off(`convs/${usr_conv.id}/tasks`);
  db.off(`convs/${usr_conv.id}/materials`);
  db.off(`convs/${usr_conv.id}/messages`);
  db.off(`convs/${usr_conv.id}/members`);
  cache.remove(`watched_${usr_conv.id}`);
  dispatch({ type: UPDATE_CONV, payload: usr_conv });
  dispatch({ type: LOAD_TASKS, payload: { id: usr_conv.id, data: {} } });
  dispatch({ type: LOAD_MATERIALS, payload: { id: usr_conv.id, data: {} } });
  dispatch({ type: LOAD_MEMBERS, payload: { id: usr_conv.id, data: {} } });
  dispatch({ type: LOAD_MESSAGES, payload: { id: usr_conv.id, data: {} } });
};



// WEBPACK FOOTER //
// ./src/actions/conv.js